import {FunctionComponent} from "react";

export const NotFoundPage: FunctionComponent = () => (
  <main>Page Not Found</main>
);
